export default "__VITE_ASSET__fu6Q_p6a__"